"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var block_ui_module_1 = require("../block-ui.module");
function BlockUI(value) {
    return function (target, propertyKey, descriptor) {
        target[propertyKey] = block_ui_module_1.BlockUIServiceInstance.decorate(value);
    };
}
exports.BlockUI = BlockUI;



//////////////////
// WEBPACK FOOTER
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/node_modules/ng-block-ui/dist/lib/decorators/block-ui.decorator.js
// module id = zsaI
// module chunks = 3